import React from 'react';

export default () => <h3>Protected</h3>;


// WEBPACK FOOTER //
// ./src/SecureProtected.js